// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

import {sendEmail, sendEmailWithRecipient} from 'backend/email';

$w.onReady(function () {
  $w("#dataset1").onAfterSave(sendFormData);
  $w("#dataset1").onBeforeSave(validate);
});

function sendFormData() {
  const subject = `נרשם חדש לספיד דייט ${$w("#input1").value}`;
  const body = `Type Here: ${$w("#input1").value}
    \שם מלא: ${$w("#input1").value}
    \מייל: ${$w("#input2").value}
    \טלפון: ${$w("#input3").value}
    \גיל: ${$w("#input4").value}
    \מקור: ${$w("#dropdown1").value}
    \מין: ${$w("#radioGroup1").value}
   `;
//  const recipient = $w("#input2").value;
 
//  sendEmailWithRecipient(subject, body, recipient)
 //   .then(response => console.log(response)); 
    
    
    
  sendEmail(subject, body)
    .then(response => console.log(response));
}

function validate() {
	let num = $w("#input3").value;
    if (num.length < 9) {
    	$w("#invalidNum").show();
    	return false;
    }
    return true;
}
